import { render, staticRenderFns } from "./SideBarFilters.vue?vue&type=template&id=01ed4eda&"
import script from "./SideBarFilters.vue?vue&type=script&lang=js&"
export * from "./SideBarFilters.vue?vue&type=script&lang=js&"
import style0 from "./SideBarFilters.vue?vue&type=style&index=0&id=01ed4eda&prod&scope=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports